const riot = require('riot');

riot.tag2('atom-loading-slow', '<div class="f fc fclm p16 rounded-12 bg-white text-label_dark_primary box-shadow-primary" if="{isSlow}"> <div class="text-center fs12 lh16 mb12">読み込みに時間がかかっています</div> <button class="button primary" type="button" onclick="{reload}">再読み込み</button> </div>', 'atom-loading-slow,[data-is="atom-loading-slow"]{display:block;pointer-events:auto}', '', function(opts) {

    const SLOW_LOADING_MS = 5000;

    this.on('mount', () => {
      if (!spat.isBrowser) return ;

      this.slowTimer = setTimeout(() => {
        this.update({ isSlow: true });
      }, SLOW_LOADING_MS);
    });

    this.on('unmount', () => {
      clearTimeout(this.slowTimer);
    });

    this.reload = () => {
      location.reload();
    };
});